import { FaYoutube } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const youtubeBaseSettings: SocialPlatformBaseSettings = {
  name: "YouTube",
  icon: FaYoutube,
  fields: {
    title: "required",
    caption: "optional", // Description field
    location: "optional",
    userTags: "optional", // In description/comments
  },
  limits: {
    caption: 5000, // Description limit
    videos: 1,
    hashtags: 15, // Recommended max in description
  },
  notes: ["Description (caption) is important for SEO."],
  postTypes: {
    short: {
      nameSuffix: " Short",
      limits: { videoDurationSeconds: 60, images: 0 },
      notes: [
        "Vertical video, max 60 seconds.",
        "Title limit 100 characters (~70 visible).",
      ],
    },
    video: {
      nameSuffix: " Video", // Long form
      limits: { videoDurationSeconds: 12 * 60 * 60, images: 0 }, // 12 hours max
      notes: [
        "Standard long-form video.",
        "Title limit 100 characters (~70 visible).",
      ],
    },
  },
};
